import React, { useEffect, useContext, useState } from "react";
import { useBreadcrumb } from "../Breadcrumb/BreadcrumbContext";
import { useSidebar } from "../NewSideBar/SidebarContext";
import { ColorContext } from "../../contexts/color-context/ColorContext";
import { useAsyncFn } from "../../hooks/use-async-fn";
import FederationTiles from "../FederationTiles";
import { useFederation } from "./FederationContext";

type FederationSelectionProps = {
  authContext: any;
};

const FederationSelection: React.FC<FederationSelectionProps> = ({
  authContext,
}) => {
  const { setFedId, setPlatformLogo } = useFederation();
  const { getApplication } = authContext;
  const { setBreadcrumbItems } = useBreadcrumb();
  const { mainMenuItems, setActiveSubItem, setIsSideBarMenuDisabled } =
    useSidebar();
  const [, setElementColorCode] = useState("");
  const getApplicationFn = useAsyncFn({
    promiseFn: getApplication,
  });
  const colorContext = useContext(ColorContext);
  const { setFedPlatformName } = colorContext;
  useEffect(() => {
    const applicationData = getApplicationFn.data && getApplicationFn.data;

    if (
      getApplicationFn.data &&
      applicationData &&
      applicationData.color_scheme
    ) {
      setElementColorCode(applicationData.color_scheme.element_color);
    }
  }, [getApplicationFn.data]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    localStorage.setItem("matchid", null);
    localStorage.setItem("bucketids", null);
    localStorage.setItem("federationkey", JSON.stringify(null));
    setFedId(null);
    setPlatformLogo(null);
    localStorage.setItem("federationname", "");
    localStorage.setItem("userMatchId", undefined);
    localStorage.setItem("usermatchid", undefined);
    setFedPlatformName(null);
    setBreadcrumbItems([
      { label: "Discover", path: "/entry-hub?console=Discover" },
      { label: "Curation", path: "/federation-selection" },
      { label: "Federation Selection", path: "/federation-selection" },
    ]);
    const sideBarMenuToHighlight = mainMenuItems
      .flatMap((item) => item.subMenu)
      .find((subItem) =>
        subItem.urls.some((url) => url.includes("/federation-selection")),
      )?.label;
    setActiveSubItem(sideBarMenuToHighlight);
    setIsSideBarMenuDisabled({
      fed: false,
      ianda: true,
      cp: true,
      cr: true,
      pr: true,
      ca: false,
      ah: true,
      dm: true,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // return storedPermissions?.createfederation === "no" ? (
  //   <PageNotFound />
  // ) : (
  //   <div
  //     className={styles.pageContainer}
  //     style={
  //       {
  //         "--Primary-Color-Shade-1": elementColorCode,
  //       } as React.CSSProperties
  //     }
  //   >
  //     <button className={styles.backButton} onClick={handleBack}>
  //       <img
  //         src={SimpleBack}
  //         alt="back"
  //         style={{ top: "5px", marginRight: "5px", position: "relative" }}
  //       />{" "}
  //       Back
  //     </button>

  //     <div className={styles.container}>
  //       <h2 style={{ fontFamily: "Roboto", fontSize: "18px", fontWeight: 600 }}>
  //         Choose an existing federation or Create a new federation?
  //       </h2>
  //       <div className={styles.options}>
  //         <div className={styles.tile} onClick={chooseFederation}>
  //           <span className={styles.icon}>
  //             <img src={DownloadIcon} alt="existing" />
  //           </span>
  //           <p>Choose existing federation</p>
  //         </div>
  //         <div className={styles.tile} onClick={handleOrganizationSelection}>
  //           <span className={styles.icon}>
  //             <img src={PlusIcon} alt="new" />
  //           </span>
  //           <p>Create new federation</p>
  //         </div>
  //       </div>
  //     </div>
  //   </div>
  // );
  return <FederationTiles authContext={authContext} />;
};

export default FederationSelection;
